import * as React from "react"

export default ({ data }: any) => {
    const [blockedIframe, setBlockedIframe] = React.useState<boolean>(true)

    const getId = (url: string): string => {
        let mapId = url.replace(/^(\w|\W)+mid=((\w|\-)+)(&.*)/gi, '$2')
        return mapId
    }

    const unlocked = () => {
        setBlockedIframe(false)
    }

    React.useEffect(() => {
        getId(data.url)
        window.onscroll = () => setBlockedIframe(true)  
    })

    return (
        // <div id="ab-map" style={{ width: '100%', minHeight: '100vh' }}></div>
        <div id='map-container' onClick={unlocked} className={`${blockedIframe ? 'blocked-map' : ''}`}>
            <iframe data-aos='fade-up' className={`solution-map`} src={`https://www.google.com/maps/d/embed?mid=${getId(data.url)}`} width="640" height="480"></iframe>
        </div>
    )
}